var _ref2, _ref3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnpin = function SvgUnpin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.68403 1.10103C6.98304 0.802129 7.34982 0.579874 7.75317 0.453171C8.15652 0.326468 8.58451 0.299066 9.00073 0.373296C9.41695 0.447526 9.80908 0.621191 10.1438 0.879519C10.4784 1.13785 10.7458 1.47319 10.923 1.85703L11.8425 3.84753C12.1356 4.48319 12.5693 5.04397 13.1109 5.48753C13.6524 5.93109 14.2876 6.24584 14.9685 6.40803L18.6495 7.28403C20.6475 7.75953 21.3495 10.242 19.8975 11.694L16.59 15L22.17 20.58C22.2774 20.6839 22.3631 20.808 22.422 20.9453C22.4809 21.0826 22.5118 21.2302 22.5131 21.3796C22.5143 21.529 22.4857 21.6771 22.4291 21.8153C22.3725 21.9536 22.2889 22.0791 22.1832 22.1847C22.0775 22.2903 21.9519 22.3738 21.8136 22.4303C21.6753 22.4868 21.5272 22.5152 21.3778 22.5138C21.2284 22.5124 21.0808 22.4813 20.9436 22.4223C20.8064 22.3633 20.6823 22.2775 20.5785 22.17L15 16.59L11.694 19.8975C10.242 21.3495 7.75953 20.6475 7.28403 18.6495L6.40803 14.9685C6.24584 14.2876 5.93109 13.6524 5.48753 13.1109C5.04397 12.5693 4.4832 12.1356 3.84753 11.8425L1.85703 10.923C1.47319 10.7458 1.13785 10.4784 0.879519 10.1438C0.621191 9.80908 0.447526 9.41695 0.373296 9.00073C0.299066 8.58451 0.326468 8.15652 0.453171 7.75317C0.579874 7.34982 0.802129 6.98304 1.10103 6.68403L6.68403 1.10103ZM8.88003 2.79903C8.85473 2.74412 8.81653 2.69614 8.76868 2.65918C8.72083 2.62222 8.66476 2.59737 8.60523 2.58677C8.54571 2.57616 8.48451 2.5801 8.42684 2.59825C8.36917 2.61641 8.31674 2.64824 8.27403 2.69103L2.69103 8.27403C2.64824 8.31674 2.61641 8.36917 2.59825 8.42684C2.5801 8.48451 2.57616 8.54571 2.58677 8.60523C2.59737 8.66476 2.62222 8.72083 2.65918 8.76868C2.69614 8.81653 2.74412 8.85473 2.79903 8.88003L4.79103 9.79953C5.73526 10.2356 6.56822 10.8802 7.22714 11.6849C7.88607 12.4896 8.35378 13.4333 8.59503 14.445L9.47103 18.126C9.48625 18.1911 9.51858 18.2509 9.56466 18.2992C9.61074 18.3476 9.66891 18.3828 9.73314 18.4011C9.79737 18.4195 9.86535 18.4204 9.93002 18.4036C9.9947 18.3869 10.0537 18.3532 10.101 18.306L18.306 10.101C18.3532 10.0537 18.3869 9.9947 18.4036 9.93002C18.4204 9.86535 18.4195 9.79737 18.4011 9.73314C18.3828 9.66891 18.3476 9.61074 18.2992 9.56466C18.2509 9.51858 18.1911 9.48625 18.126 9.47103L14.445 8.59503C13.4329 8.35392 12.4887 7.88612 11.6837 7.2269C10.8787 6.56769 10.234 5.73427 9.79803 4.78953L8.88003 2.79903Z",
      fill: "#041F47"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M21 3L4 20",
      stroke: "#041F47",
      strokeWidth: 2,
      strokeLinecap: "round"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgUnpin, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/unpin.9192b65b.svg";
export { ForwardRef as ReactComponent };